export const surfacesSchema = {
	schema: {
		title: 'surfaces schema',
		description: 'Surfaces Schema',
		version: 1,
		primaryKey: 'code',
		type: 'object',
		properties: {
			code: {
				type: 'string',
				maxLength: 250,
			},
			name: {
				type: 'string',
			},
			image: {
				type: 'string',
			},
			is_rr_required: {
				type: 'boolean',
			},
			project_classifications: {
				type: 'array',
				items: {
					type: 'object',
					properties: {
						code: { type: 'string' },
						name: { type: 'string' },
						image: { type: 'string' },
					},
				},
			},
		},
		required: ['code', 'name', 'image', 'is_rr_required'],
	},
	migrationStrategies: {
		1: (oldDoc: Record<string, unknown>): Record<string, unknown> => ({
			...oldDoc,
			project_classifications: Array.isArray(oldDoc.project_classifications) ? oldDoc.project_classifications : [],
		}),
	},
};
